import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import currency from '../../helpers/currency'
import { ButtonBase, useMediaQuery, Typography, Grid, Button as ButtonMaterial, Box } from '@material-ui/core'
import { addItem } from '../../flux/cart'
import { setNotification } from '../../flux/notification'
import { useDispatch } from 'react-redux'
import CartSrc from '../../assets/cart.png'

const Item = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const dispatch = useDispatch()

  const addToCart = event => {
    event.preventDefault()
    event.stopPropagation()
    dispatch(setNotification({
      type: 'success',
      message: `Se han agregado 1 ${props.title} a tu carrito`
    }))
    dispatch(addItem({ ...props, quantity: 1 }))
  }

  return (
    <WrapperItem to={`/item/${props.id}`}>
      <ItemBody as='div'>
        <Picture src={props.picture} />
        <Data>
          <Title variant={!isMobile ? 'h6' : 'subtitle1'}>{props.title}</Title>
          <Price variant={!isMobile ? 'h5' : 'h6'}> $ {currency.formatMoney(props.price)} <span>MXN</span></Price>
          <Grid container spacing={2} component={Box} pt={1}>
            <Grid item xs={6}>
              <ButtonMaterial fullWidth style={{ minHeight: '40px', fontSize: '.75em', textTransform: 'none', background: '#f3f5f7' }} variant='contained' size='small'>Requisitos</ButtonMaterial>
            </Grid>
            <Grid item xs={6}>
              <ButtonMaterial fullWidth style={{ minHeight: '40px', fontSize: '.75em', textTransform: 'none' }} color='primary' variant='contained' size='small' onClick={addToCart}><Cart src={CartSrc} />Agregar</ButtonMaterial>
            </Grid>
          </Grid>
        </Data>
      </ItemBody>
    </WrapperItem>
  )
}

Item.propTypes = {
  id: propTypes.string,
  picture: propTypes.string,
  title: propTypes.string,
  price: propTypes.number
}

const WrapperItem = styled(Link)`
  text-decoration: none!important;
  box-sizing: border-box;
`

const ItemBody = styled(ButtonBase)`
  border: 1px solid #f1f1f1;
  background: #fff;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 300ms;
  &:hover {
    transform: scale(1.01);
    box-shadow: 2px 2px 10px #f1f1f1;
  }
`
const Picture = styled.img`
  width: 100%;
  display: block;
  height: 250px;
  min-height: 250px;
  max-height: 250px;
  object-fit: cover;
  border-bottom: 1px solid #cdcdcd;
  @media screen and (max-width:960px){
    height: 200px;
    min-height: 200px;
    max-height: 200px;
  }
  @media screen and (max-width:500px){
    height: 250px;
    min-height: 250px;
    max-height: 250px;
  }

`
const Title = styled(Typography)`
  padding: 0px;
  margin: 0px;
  text-align: left;
  margin-bottom: 10px;
  line-height: 1.2em;
  font-weight: bold;
  color: var(--second)!important;
  @media(max-width:500px) {
    font-size: 1.5em!important;
  }
  @media(max-width:400px) {
    font-size: 1.3em!important;
  }
`
const Price = styled(Typography)`
  text-align: left;
  font-weight: bold;
  color: var(--first)!important;
  & span {
    font-size: .7em;
  }
  @media(max-width:500px) {
    margin: 20px 0px;
    font-size: 1.8em!important;
  }
  @media(max-width:500px) {
    margin: 10px 0px;
    font-size: 1.5em!important;
  }
`
const Data = styled.div`
  padding: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`
const Cart = styled.img`
  display: none;
  @media screen and (max-width:500px) {
    display: inline;
  }
`

export default Item
